import { render, staticRenderFns } from "./UploadAvatar.vue?vue&type=template&id=52350462&scoped=true"
import script from "./UploadAvatar.vue?vue&type=script&lang=js"
export * from "./UploadAvatar.vue?vue&type=script&lang=js"
import style0 from "./UploadAvatar.vue?vue&type=style&index=0&id=52350462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52350462",
  null
  
)

export default component.exports